import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { newProducts } from '../../data/products';
import { ProductCard } from './ProductCard';
export function ProductsSection() {
  return <section id="nouveautes" aria-labelledby="products-title" className="w-full scroll-mt-20 bg-cream py-24 md:py-32" data-id="element-85" data-mp="1vrubg6s4hzl7">
      <div className="mx-auto max-w-7xl px-5 md:px-8" data-id="element-86" data-mp="1zps2zg9d8xrr">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between" data-id="element-87" data-mp="2niibtglz30xt">
          <h2 id="products-title" className="max-w-2xl font-serif text-5xl leading-[1] text-aloe-900 md:text-7xl" data-id="element-88" data-mp="2sgs6zr7p61jf">
            Nos nouveaux <span className="italic text-sage" data-id="element-89" data-mp="2eg91aqqpf7kf">cosmétiques.</span>
          </h2>
          <Link to="/produits" className="inline-flex items-center gap-2 self-start whitespace-nowrap text-sm font-semibold text-aloe-900 md:self-auto" data-id="element-90" data-mp="2jesqr14ib1hj">
            Toute la gamme <ArrowRightIcon className="h-4 w-4" data-id="element-91" data-mp="181qbc9e58hyy" />
          </Link>
        </div>

        <div className="mt-16 space-y-24 md:mt-24 md:space-y-32" data-id="element-92" data-mp="62fx44zncjpc">
          {newProducts.map((product, i) => <ProductCard key={product.id} product={product} reversed={i % 2 === 1} data-id="element-93" data-mp="157oav0e1s0r" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}